<script lang="ts">
    import {doShow as showAlert} from "src/components/cabinet/#common/alert/store"
    import {getAllSettingsOption, updateAllSettingsOption, deleteSettingOption} from 'src/components/cabinet/#services/settingsOption'
    import Modal from 'src/components/cabinet/#common/modal/Modal.svelte.ts'
    import IconifyIcon from '@iconify/svelte'
    import cogIcon from '@iconify/icons-fa-solid/cog'
    import deleteIcon from '@iconify/icons-fa-solid/trash-alt'

    getAllSettingsOption.reset()
    getAllSettingsOption.send({ data: { tab: 'general' }})

    let deleteOptionIndex
    let deleteOptionModal = false
    let unsichtbar = []

    let settings
    $: if (!settings && $getAllSettingsOption.hasValue) {
        settings = $getAllSettingsOption.value && JSON.parse(JSON.stringify($getAllSettingsOption.value))
    }

    function changeHandler(setting) {
        if (setting.extraDetails.type === 'checkbox') {
            setting.value = 0
        } else if (setting.extraDetails.type === 'text' || setting.extraDetails.type === 'number') {
            setting.value = ''
        }
    }

    function addOption() {
        settings.push({
            "scope": "",
            "key": "",
            "value": "",
            "previousValue": "",
            "description": "",
            "extraDetails": {
                "tab": "general",
                "type": "text"
            }
        })
        settings = settings
        setTimeout(function (){
            window.scrollTo(0,document.body.scrollHeight)
        }, 100)
    }

    function deleteOption() {
        deleteSettingOption.send({data: {clientKey: settings[deleteOptionIndex].scope+'.'+settings[deleteOptionIndex].key}})
        settings.splice(deleteOptionIndex, 1)
        settings = settings
        deleteOptionModal = false
    }

    async function save() {
        try {
            settings.forEach(function(option){
                if ('id' in option) delete option.id
                option.value = option.value.toString()
            });

            await updateAllSettingsOption.request({ data: { clientKeys: settings } })

            showAlert.set({
                status: 'success',
                text: 'Settings saved successfully'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            getAllSettingsOption.reset()
        }
    }
</script>

<div class="settings-list">
    {#if !settings && $getAllSettingsOption.loading}
        <tr>
            <td class="text-center" colSpan="3">Loading...</td>
        </tr>
    {:else if !settings && ($getAllSettingsOption.error || !$getAllSettingsOption.hasValue) }
        <tr>
            <td class="text-center" colspan="3">Something went wrong. Try refreshing the page.</td>
        </tr>
    {:else if settings}
        {#each settings as { scope, key, value, description, extraDetails }, i}
            {#if extraDetails && Object.keys(extraDetails).length != 0}
                <div class="form-group">
                    <div class="input-group mb-3">
                        <input type="text" class="form-control" placeholder="Description" bind:value={description}>
                        {#if extraDetails.type == 'text' || extraDetails.type == 'string'}
                            <input type="text" class="form-control" placeholder="Enter value..." bind:value={value}>
                        {:else if extraDetails.type == 'number'}
                            <input type="number" class="form-control" placeholder="Enter value..." bind:value={value}>
                        {:else if extraDetails.type == 'checkbox'}
                            <div class="input-group-text">
                                <input class="form-check-input mt-0" type="checkbox" bind:checked={value}>
                            </div>
                        {/if}
                        <button class="btn btn-secondary" on:click="{()=>unsichtbar[i]=!unsichtbar[i]}">
                            <IconifyIcon icon={cogIcon}/>
                        </button>
                        <button class="btn btn-danger" on:click={() => { deleteOptionModal = true; deleteOptionIndex = i }}>
                            <IconifyIcon icon={deleteIcon}/>
                        </button>
                    </div>
                    {#if unsichtbar[i]}
                        <div class="form-group option-details-panel">
                            <label>Type / Scope / Key</label>
                            <div class="input-group mb-3">
                                <select class="form-select" style="max-width: 130px" bind:value={extraDetails.type} on:change={(e) => changeHandler(settings[i])}>
                                    <option value="text">Text</option>
                                    <option value="number">Number</option>
                                    <option value="checkbox">Checkbox</option>
                                </select>
                                <input type="text" class="form-control" placeholder="Scope" bind:value={scope}>
                                <input type="text" class="form-control" placeholder="Key" bind:value={key}>
                            </div>
                        </div>
                    {/if}
                </div>
                <hr>
            {/if}
        {/each}
        <Modal bind:visible={deleteOptionModal}>
            <svelte:fragment slot="content">
                <div class="modal-custom__title">Delete option</div>
                <div class="modal-custom__text">Are you sure you want to delete the option?</div>
                <div class="modal-custom__footer">
                    <button class="btn btn-cancel" on:click={() => { deleteOptionModal = false }}>Cancel</button>
                    <button class="btn btn-primary btn-danger" on:click={deleteOption}>Remove!</button>
                </div>
            </svelte:fragment>
        </Modal>
        <button class="btn btn-success mt-3" on:click={addOption}>Add new</button>
        <button class="btn btn-primary mt-3" on:click={save}>Save</button>
    {/if}
</div>

<style>
    .settings-list {
        max-width: 700px;
    }

    .option-details-panel {
        background: #e9eaeb;
        border: 1px solid #ced4da;
        border-radius: 6px;
        padding: 5px 10px 0;
    }

    .settings-list .btn-danger {
        padding: 10px 15px;
    }
</style>
